import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import DownloadPdf from 'wt-react/dist/components/DownloadPdf/DownloadPdf';
import s from './ClientModel.css';


class ClientModel extends PureComponent {

  render() {
    const {
      client,
      token,
      pdfEnabled,
    } = this.props;

    const mod = client.fullTermModels.filter((x) => {
      return x.name === 'Client Portfolio';
    })[0];

    const hasPreferred = client.fullTermModels.length > 1 ? true : false;

    // Set the ID of the client for the PDF
    const pdfAdhocInputs = [
      {
        "name": "id",
        "type": "string",
        "value": client.id,
      },
    ]

    return (
      <div style={{marginTop:'60px'}}>
          {!hasPreferred &&
            <div className='row'>
              <div className="col-md-12">
                <div className={s.clientResultsScoreTitle} style={{ paddingBottom: '10px' }}>
                  {client.firstName}'s Portfolio may be the best behavioral finance profile match compared to other models.
                  </div>
              </div>
            </div>
          }
          {hasPreferred &&
            <div>
              <div className='row'>
                <div className="col-md-9">
                  <div className={s.clientResultsScoreTitle}>
                    {client.firstName}'s Portfolio may have a <span style={{color:'#5060F6', fontWeight:'700'}}>{Math.round(mod.metGoalPct * 100)}% chance</span> to meet the goal.
                  </div>
                </div>
                <div className="col-md-3" style={{height: '40px'}}>
                  {/* Show the download pdf component */}
                  {pdfEnabled ? <DownloadPdf 
                        token={token}
                        clientEmail={client.advisorEmail}
                        configId={`${process.env.REACT_APP_SEISMIC_PDF_ID}`}
                        initialButtonText='Download Report'
                        dataspanApiUrl={`${process.env.REACT_APP_API_URL}`.replace('/bhvfinV2', '')}
                        dpdApiUrl={`${process.env.REACT_APP_DPD_URL}`}
                        adhocInputs={pdfAdhocInputs}
                        submitOnLoad={false}
                        isAnonymous={false}
                        openModalOnLoad={false}
                        modalTitleText='Customize your report'
                        waitingMessageText='Please wait while your report is generated'
                      /> : null }
                </div>
              </div>
              <div className='row' style={{marginTop:'60px'}}>
                <div className="col-md-12">
                  <div className={s.clientResultsScore}>
                    Based on {client.firstName}'s assessments, there may be a model that could provide a better match for {client.firstName}’s behavioral
                    finance profile. {client.firstName} could experience a smoother retirement journey,
                    while still achieving financial goals.<br /><br />
                    When analyzing {client.firstName}'s portfolio against other models, many behavioral and financial
                    characteristics such as {client.firstName}'s innate reaction to losses, {client.firstName}'s
                    sensitivity to risk vs. reward, and both the portfolio and model's potential for future
                    gains and losses were considered.<br /><br />
                    <span style={{fontWeight:'700'}}>As the advisor, you may want to suggest to {client.firstName} one of the following models,
                    which may better reflect the behavioral profile and preferences:</span>
                  </div>
                </div>
              </div>
            </div>
          }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.params.token,
    pdfEnabled: state.params.pdfEnabled,
  };
}

export default connect(mapStateToProps, {})(ClientModel);



// WEBPACK FOOTER //
// ./src/components/AdvisorMode/ClientModel.js